import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Direcciones } from '../model/direcciones';
import { VSaveDireccionAndAsociateModel } from '../model/v-save-direccion-and-asociate.module';

@Injectable()
export class DireccionesService {


  selectedDireccion: Direcciones;
  DireccionesList: Direcciones[];

  PATH = '';

  constructor(private http: HttpClient) {
    this.PATH = environment.API_BASE;
  }

  //  Coge todas las direcciones
  getAllAddresses(): Observable<Direcciones[]> {
    return this.http.get<Direcciones[]>(this.PATH + '/Dirs');
  }


  setAddressDefault(id_address: number) {
    // Dirs/DirDefault/{idDir}/{idUser}
    return this.http.get(this.PATH + '/Dirs/DirDefault/' + id_address + '/0', { observe: 'response' });
  }
  // crea una nueva direccion
  createAddress(direccion: Direcciones): Observable<number> {
    return this.http.post(this.PATH + '/Dirs/AddDirAndAssociateWithUser', direccion, { observe: 'response' })
      .pipe(map(success => success.status));
  }

  //  Update address
  updateAddress(direccion: Direcciones): Observable<number> {
    return this.http.post(this.PATH + '/Dirs/AddDirAndAssociateWithUser', direccion, { observe: 'response' })
      .pipe(map(success => success.status));
  }

  //  Delete address
  deleteAddressById(directionId: number): Observable<number> {
    return this.http.get<number>(this.PATH + `/Dirs/Delete/${directionId}`);
  }

  getDirsOfSuplantedUser(userId: number): Observable<Direcciones[]> {
    return this.http.get<Direcciones[]>(environment.API_BASE + '/Dirs/Suplant/' + userId)
      .pipe(map((direcciones: Direcciones[]) => direcciones
        .map((direccion: Direcciones) => Direcciones.toModel(JSON.stringify(direccion)))));
  }

  addDireccionAsociate(direccion: VSaveDireccionAndAsociateModel) {
    return this.http.post(
      this.PATH + '/Dirs/SaveDireccionAndAsociate',
      direccion);
  }

  resetDireccionCentro(idCentro: number) {
    return this.http.get(
      this.PATH + '/Dirs/ResetDireccionCentro?idCentroInventario=' + idCentro
    );
  }

}








